<template>
    <div>
        <div v-for="(campaign, k) in campaigns" :key="k">
            <div :id="'campaign_' + campaign.id"
                 bzb-track-category="Rewards"
                 bzb-track-action="View rewards"
                 :bzb-track-label="campaign.id + '|' + campaign.name">
                {{campaign.name}}
            </div>
        </div>
    </div>
</template>
<script>
import { TrackingService, TrackElement } from "@/helper/TrackingHelper.js";

export default {
    name: "ElemTracking",
    data: function() {
        return {
            campaigns: [
                { id: "1", name: "campaign 1" },
                { id: "2", name: "campaign 2" },
                { id: "3", name: "campaign 3" },
                { id: "4", name: "campaign 4" },
            ],
            trackingService: new TrackingService(this),
            trackElem: null,
        };
    },
    created: function() {
        this.trackElem = new TrackElement(this.trackingService);
        this.trackingService.screenName('tracking_test');
        this.trackingService.event('cate_tracking', 'view_page_tracking');
    },
    mounted: function() {
        this.trackingElementCampaignList(this.campaigns);
    },
    methods: {
        trackingElementCampaignList: function(list) {
            this.$nextTick(() => {
                for (var campaign of list) {
                    var id = 'campaign_' + campaign.id;
                    this.trackElem.registerElemTrack(id);
                }
            });
        },
    },
}
</script>
